import { Box, Container, Grid, Stack, Tab, Tabs, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Actionbutton from '../../components/Actionbutton';
import { CustomTabPanel, a11yProps } from '../../components/CustomTabPanel';
import DeleteModel from '../../components/Deletemodle';
import Header from '../../components/Header';
import { apidelete, apiget } from '../../service/api';
import EditModel from './Edit';
import Other from './Other';
import Overview from './Overview';
import PrintInvoice from './invoicetoPDF';
import {PDFDownloadLink} from '@react-pdf/renderer';
import InvoiceTemplate from "./invoiceTemplate";


const View = () => {

    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [invoiceData, setInvoiceData] = useState({});
    const [userAction, setUserAction] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [openPrint, setOpenPrint] = useState(false);
    const [opendelete, setOpendelete] = useState(false);
    const [value, setValue] = useState(0);
    const navigate = useNavigate()
    const params = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const handleOpenPrint = () => setOpenPrint(true);
    const handleClosePrint = () => setOpenPrint(false);
    // open Edit model
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    // open delete model
    const handleOpenDelete = () => setOpendelete(true);
    const handleCloseDelete = () => setOpendelete(false);

    // tab
    const handleChange = (event, newValue) => setValue(newValue);

    const back = () => {
        navigate('/dashboard/krainvoices')
    }

    const fetchdata = async () => {
        setIsLoading(true)
        try {
            const result = await apiget(`api/krainvoice/view/${params.id}`);
            if (result && result.status === 200) {
                setInvoiceDetails(result.data);
            }
        } catch (error) {
            console.error("Error fetching invoice details:", error);
        }
        setIsLoading(false)
    };


    // delete api
    const deletedata = async () => {
        await apidelete(`api/krainvoices/delete/${params.id}`)
        navigate('/dashboard/krainvoices')
    }

    useEffect(() => {
        fetchdata();
    }, [userAction])

    return (
        <div>
            <PrintInvoice open={openPrint} handleClose={handleClosePrint} setUserAction={setUserAction} invoiceData={invoiceDetails} setInvoiceData={setInvoiceData}/>
            {/* Edit User Model */}
            <EditModel open={openEdit} handleClose={handleCloseEdit} setUserAction={setUserAction} invoiceData={invoiceDetails} />

            {/* open Delete Model */}
            <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deletedata} id={params.id} />

            <Container maxWidth>
                <Grid container display="flex" alignItems="center">
                    <Stack direction="row" alignItems="center" mb={3} justifyContent={"space-between"} width={"100%"}>
                        <Header
                            title="Invoice Details"
                        />
                        <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
                            {/* Action Butoon */}
                            <Button variant="contained" onClick={handleOpenPrint}>Print</Button>
                            {Object.keys(invoiceData).length > 0 ?
                            <PDFDownloadLink document={<InvoiceTemplate data={invoiceData}/>} fileName={`${invoiceData?.InvoiceNumber}.pdf`} style={{textDecoration: 'none', color: 'blue'}}>{({ blob, url, loading, error }) => loading ? 'Preparing Document...' : 'Download PDF'}</PDFDownloadLink>
                            : null}
                            <Actionbutton
                                handleOpenEdit={handleOpenEdit}
                                handleOpenDelete={handleOpenDelete}
                                back={back}
                            />
                        </Stack>
                    </Stack>
                </Grid>

                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "0px" }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="OVERVIEW" {...a11yProps(0)} />
                            <Tab label="OTHER" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <Overview data={invoiceDetails} isLoading={isLoading} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Other data={invoiceDetails} isLoading={isLoading} />
                    </CustomTabPanel>
                </Box>
            </Container>
        </div>
    )
}

export default View
